// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_ALBUM_OR_ARTICLE = "Pridaj album / \u010dl\u00e1nok";
export const ADD_POST = "Pridaj pr\u00edspevok";
export const CREATE_ALBUM = "Vytvor album";
export const DRAFTS = "Rozp\u00edsan\u00e9 \u010dl\u00e1nky";
export const PROFILE_OF_USER = "Profil pou\u017e\u00edvate\u013eky";
export const USER_LIKE = "Pridaj k ob\u013e\u00faben\u00fdm";
export const USER_UNLIKE = "Odober z ob\u013e\u00faben\u00fdch";
export const WRITE_ARTICLE = "Nap\u00ed\u0161 \u010dl\u00e1nok";
export const WRITE_SHORT_MESSAGE = "Nap\u00ed\u0161 kr\u00e1tku spr\u00e1vu";
